import { render } from "./ZeroTouch.vue?vue&type=template&id=1d5a55c6&ts=true"
import script from "./ZeroTouch.vue?vue&type=script&lang=ts"
export * from "./ZeroTouch.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__